export const TRANSACTIONS = "transactions";
export const AMOUNT_IN_PENCE = "amountInPence";
export const AMOUNT = "amount";
export const TRANSACTION_TOTAL = "transactionsTotal";
